"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPassengersInfo = getPassengersInfo;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const getLuggageCount_1 = require("./getLuggageCount");
function getPassengersInfo(passengers) {
    const children = passengers.filter((p) => p.type === legacy_enums_1.PassengerType.Child);
    const childrenCount = children.length;
    const adults = passengers.filter((p) => [legacy_enums_1.PassengerType.Adult, legacy_enums_1.PassengerType.Lead].includes(p.type));
    const adultsCount = adults.length;
    const childSeats = passengers.map((p) => p.childSeatType).filter((seat) => !!seat);
    const luggageCount = (0, getLuggageCount_1.getTotalLuggageCount)(passengers);
    return {
        adults,
        adultsCount,
        children,
        childrenCount,
        childSeats,
        luggageCount,
    };
}
//# sourceMappingURL=getPassengersInfo.js.map